import React, { useEffect } from 'react';
import { Trans } from '@lingui/react/macro';

// Material UI
import Grid from '@mui/material/Grid';

// Data
import { SUPPORT_EMAIL } from '../../_configuration';
import { recordEvent } from '../../services/user.service';

// Components
import { MailLink, Text } from '../_core/typography.components';
import { useAuthContext } from '../../providers/auth.provider';

const NotFoundPage = () => {
  const { firebaseUser } = useAuthContext();

  useEffect(() => {
    if (firebaseUser) {
      recordEvent({
        eventName: 'Page Not Found Error',
        firebaseUser,
        props: { path: window.location.pathname },
      });
    }
  }, [firebaseUser]);

  return (
    <>
      <Grid item xs={12} justifyContent="center" alignItems="center">
        <Text large align="center">
          <h1>
            <Trans>Sorry, we couldn't find that page.</Trans>
          </h1>
        </Text>
        <Text align="center">
          <Trans>
            Go to <a href="/">Solve's home page</a> or contact us by email at{' '}
            <MailLink href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</MailLink> with any other issues or questions.
          </Trans>
        </Text>
      </Grid>
    </>
  );
};

export default NotFoundPage;
